export const API_BASE = import.meta.env.VITE_API_BASE_URL || "https://rollo-api.mydash.workers.dev";

const TOKEN_KEY = "rollo.session.v1";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export async function api(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof Blob) && !(options.body instanceof ArrayBuffer)) {
    headers.set("Content-Type", "application/json");
  }
  headers.set("Accept", "application/json");
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    body: options.body && !(options.body instanceof Blob) && !(options.body instanceof ArrayBuffer)
      ? JSON.stringify(options.body)
      : options.body
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const error = new Error(payload.error || "No se ha podido completar la acción.");
    error.status = response.status;
    throw error;
  }
  if (response.status === 204) return {};
  return response.json();
}

export async function upload(path, file) {
  const token = getToken();
  const response = await fetch(`${API_BASE}${path}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": file.type || "image/jpeg",
      Accept: "application/json"
    },
    body: file
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error || "No se ha podido subir la imagen.");
  }
  return response.json();
}
